"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortArray = exports.sortArray = void 0;
var get_1 = __importDefault(require("lodash/get"));
var react_1 = require("react");
var react_redux_firebase_1 = require("react-redux-firebase");
var SortContext_1 = __importDefault(require("./SortContext"));
var nullOrUndefined = function (v) { return v === undefined || v === null; };
function sortArray(arr, sortObj, extractorMapper, emptyValMapper, sortMapper) {
    if (!sortObj || !arr || !(0, react_redux_firebase_1.isLoaded)(arr) || (0, react_redux_firebase_1.isEmpty)(arr) || !arr.length) { // Probably most of it would just be arr?.length
        return arr;
    }
    var sortedArr = __spreadArray([], __read(arr), false);
    var extractVal1 = (extractorMapper === null || extractorMapper === void 0 ? void 0 : extractorMapper[sortObj.key]) || (function (item) { return (0, get_1.default)(item, sortObj.key); });
    var extractVal = function (item) { return (sortMapper === null || sortMapper === void 0 ? void 0 : sortMapper[sortObj.key]) ? sortMapper === null || sortMapper === void 0 ? void 0 : sortMapper[sortObj.key][extractVal1(item)] : extractVal1(item); };
    sortedArr.sort(function (item1, item2) {
        var _a, _b;
        var _c = __read([item1, item2].map(extractVal), 2), item1Value = _c[0], item2Value = _c[1];
        if (typeof item1Value === 'number' && typeof item2Value === 'number') {
            return (item1Value - item2Value) * sortObj.order;
        }
        var _d = __read([item1Value, item2Value]
            .map(function (val) { return typeof val === 'string' ? val.toLowerCase() : val; }), 2), item1ValueFinal = _d[0], item2ValueFinal = _d[1];
        if (nullOrUndefined(item1Value) && nullOrUndefined(item2Value) && (emptyValMapper === null || emptyValMapper === void 0 ? void 0 : emptyValMapper[sortObj.key])) {
            return ((_a = emptyValMapper === null || emptyValMapper === void 0 ? void 0 : emptyValMapper[sortObj.key](item1, sortObj.order)) !== null && _a !== void 0 ? _a : 0) - ((_b = emptyValMapper === null || emptyValMapper === void 0 ? void 0 : emptyValMapper[sortObj.key](item2, sortObj.order)) !== null && _b !== void 0 ? _b : 0);
        }
        if (nullOrUndefined(item1ValueFinal) && nullOrUndefined(item2ValueFinal)) {
            return 0;
        }
        if (nullOrUndefined(item1ValueFinal) || nullOrUndefined(item2ValueFinal)) {
            return nullOrUndefined(item1ValueFinal) ? 1 : -1;
        }
        return ((item1ValueFinal > item2ValueFinal && 1)
            || (item1ValueFinal < item2ValueFinal && -1)
            || 0) * sortObj.order;
    });
    return sortedArr;
}
exports.sortArray = sortArray;
var useSortArray = function (arr, extractorMapper, emptyValMapper, sortMapper) {
    var sort = (0, react_1.useContext)(SortContext_1.default).sort;
    return (0, react_1.useMemo)(function () { return sortArray(arr, sort, extractorMapper, emptyValMapper, sortMapper); }, [arr, sort]);
};
exports.useSortArray = useSortArray;
